import { AppConfigModel } from '../models';

export function getUrlFromImageName(appConfig: AppConfigModel, name: string): string {
  const imageResult = appConfig.images.find(image => image.nom === name);

  return imageResult?.url ?? '';
}
